import { render } from "./SellerHomeView.vue?vue&type=template&id=645e0550"
import script from "./SellerHomeView.vue?vue&type=script&lang=js"
export * from "./SellerHomeView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__